import { paperClasses as muiPaperClasses, getPaperUtilityClass } from '@mui/material';

declare module '@mui/material/Paper' {
  interface PaperPropsVariantOverrides {
    elevation: true,
    outlined: true,
    brand: true,
    subtle: true,
  }
}

export const paperClasses = {
  ...muiPaperClasses,
  brand: getPaperUtilityClass('brand'),
  subtle: getPaperUtilityClass('subtle'),
};
